module.exports = __webpack_public_path__ + "img/for-kids-1.3729ff7.webp";